import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator, levelEnumValidator } from '../../validators';

export const TranslateWordSchema = z.object({
  languages: z
    .array(languageEnumValidator)
    .min(1, 'At least one language must be provided')
    .optional()
    .default([LanguageEnum.RU]),
  level: levelEnumValidator.optional(),
  text: z.string().min(1, 'Text cannot be empty'),
});

export type ITranslateWordDto = z.infer<typeof TranslateWordSchema>;
